module.exports = __webpack_public_path__ + "static/media/Virtual-mirror-lens-4-psd_Fresh-BLUE-eng.3b702b1b.png";